import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    blogs: [],
    isBlogLoading: false,
    issingleLoading: false,
    singleblog: null,
    activeblogs: [],
    isActiveLoading: false,
    relatedblogs: [],
    isRelatedLoading: false,
    isSearchLoading: false,
    searchblogs: []

}


export const getBlogs = createAsyncThunk(
    'get_blog_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getBlogsStart());
            const response = await axios.get(`/blogs/get_blogs.php`)
            if (response?.data?.status == 'success') {

                dispatch(getBlogsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getBlogsFailure(error.response.data.message))
        }
    }
)
export const getActiveBlogs = createAsyncThunk(
    'get_active_blog_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getActiveBlogsStart());
            const response = await axios.get(`/blogs/get_active_blogs.php`)
            if (response?.data?.status == 'success') {

                dispatch(getActiveBlogsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getActiveBlogsFailure(error.response.data.message))
        }
    }
)
export const getSearchBlogs = createAsyncThunk(
    'blogs_search',
    async (searchText, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getSearchBlogsStart());
            const response = await axios.get(`/blogs/blogs_search.php?q=${searchText}`)
            if (response?.data?.status == 'success') {

                dispatch(getSearchBlogsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getSearchBlogsFailure(error.response.data.message))
        }
    }
)
export const getRelatedBlogs = createAsyncThunk(
    'get_related_blog_page',
    async ({ blogId }, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getRelatedBlogsStart());
            const response = await axios.get(`/blogs/get_related_blogs.php?blogId=${blogId}`)
            console.log('response of related blogs', response?.data)
            if (response?.data?.status == 'success') {

                dispatch(getRelatedBlogsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getRelatedBlogsFailure(error.response.data.message))
        }
    }
)
export const addBlog = createAsyncThunk(
    "addblogs",
    async (data, { dispatch, rejectWithValue }) => {
        console.log('data os blogData ', data)
        try {
            dispatch(addBlogStart());
            const response = await axios.post(`/blogs/add_blog.php`, data);
            dispatch(addBlogSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getBlogs())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addBlogFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteBlog = createAsyncThunk('deleteblog', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateBlogStart());
        const response = await axios.delete(`/blogs/delete_blog.php?id=${id}`);
        if (response?.data?.status == 'success') {
            dispatch(getBlogs())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateBlog = createAsyncThunk(
    "addblogs",
    async ({ data }, { dispatch, rejectWithValue }) => {
        console.log('data os blogData ', data)
        try {
            dispatch(updateBlogStart());
            const response = await axios.post(`/blogs/update_blog.php`, data);
            dispatch(updateBlogSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getBlogs())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(updateBlogFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const getSingleBlog = createAsyncThunk(
    'get_blog_page',
    async (slug, { dispatch, rejectWithValue }) => {
        try {
            dispatch(getSingleBlogStart());
            const response = await axios.get(`/blogs/get_singleblog.php?slug=${slug}`)
            console.log('response of products', response?.data)
            if (response?.data?.status == 'success') {

                dispatch(getSingleBlogSuccess(response?.data?.data))
            }
            return response.data

        } catch (error) {
            dispatch(getSingleBlogFailure(error.response.data.message))
        }
    }
)
const blogsSlice = createSlice({
    name: 'blogs',
    initialState,
    reducers: {
        getBlogsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getBlogsSuccess(state, action) {

            state.blogs = action.payload;
            state.isLoading = false;
        },
        getBlogsFailure(state, action) {
            state.blogs = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getActiveBlogsStart(state) {
            state.isActiveLoading = true;
            state.error = null;
        },
        getActiveBlogsSuccess(state, action) {

            state.activeblogs = action.payload;
            state.isActiveLoading = false;
        },
        getActiveBlogsFailure(state, action) {
            state.activeblogs = null;
            state.isActiveLoading = false;
            state.error = action.payload;

        },
        getSearchBlogsStart(state) {
            state.isSearchLoading = true;
            state.error = null;
        },
        getSearchBlogsSuccess(state, action) {

            state.searchblogs = action.payload;
            state.isSearchLoading = false;
        },
        getSearchBlogsFailure(state, action) {
            state.searchblogs = null;
            state.isSearchLoading = false;
            state.error = action.payload;

        },
        getRelatedBlogsStart(state) {
            state.isRelatedLoading = true;
            state.error = null;
        },
        getRelatedBlogsSuccess(state, action) {

            state.relatedblogs = action.payload;
            state.isRelatedLoading = false;
        },
        getRelatedBlogsFailure(state, action) {
            state.relatedblogs = null;
            state.isRelatedLoading = false;
            state.error = action.payload;

        },
        addBlogStart(state) {
            state.isBlogLoading = true;
            state.error = null;
        },
        addBlogSuccess(state, action) {
            state.user = action.payload;
            state.isBlogLoading = false;
        },
        addBlogFailure(state, action) {
            state.error = action.payload;
            state.isBlogLoading = false;
        },

        updateBlogStart(state) {
            state.isBlogLoading = true;
            state.error = null;
        },
        updateBlogSuccess(state, action) {
            state.user = action.payload;
            state.isBlogLoading = false;
        },
        updateBlogFailure(state, action) {
            state.error = action.payload;
            state.isBlogLoading = false;
        },
        getSingleBlogStart(state) {
            state.issingleLoading = true;
            state.error = null;
        },
        getSingleBlogSuccess(state, action) {
            console.log('action payoadddd', action.payload)
            state.singleblog = action.payload;
            state.issingleLoading = false;
        },
        getSingleBlogFailure(state, action) {
            state.singleblog = null;
            state.issingleLoading = false;
            state.error = action.payload;

        },
    }
})

export const { getBlogsSuccess, getBlogsStart, getBlogsFailure, getActiveBlogsSuccess, getActiveBlogsStart, getActiveBlogsFailure, getSearchBlogsSuccess, getSearchBlogsStart, getSearchBlogsFailure, getRelatedBlogsSuccess, getRelatedBlogsStart, getRelatedBlogsFailure, getSingleBlogSuccess, getSingleBlogStart, getSingleBlogFailure, addBlogStart, addBlogSuccess, addBlogFailure, updateBlogStart, updateBlogSuccess, updateBlogFailure } = blogsSlice.actions;

export default blogsSlice.reducer;